import { ReactElement, ReactNode } from 'react'
import { Tooltip } from '@mui/material'
import styled from 'styled-components'

interface ToolTipProps {
  titleContent: string | ReactNode
  placement?:
    | 'top'
    | 'right'
    | 'bottom'
    | 'left'
    | 'top-start'
    | 'top-end'
    | 'bottom-start'
    | 'bottom-end'
    | 'left-start'
    | 'left-end'
    | 'right-start'
    | 'right-end'
  /** Use when tooltip must appear above DataGrid or other high z-index UI (e.g. 1400). */
  popperZIndex?: number
  children: ReactElement<any, any>
}

export const ToolTip = ({
  titleContent,
  placement,
  popperZIndex,
  children
}: ToolTipProps) => {
  const isDisabledChild = Boolean(
    (children as ReactElement<{ disabled?: boolean }>)?.props?.disabled
  )

  return (
    <Tooltip
      title={<TooltipWrapper>{titleContent}</TooltipWrapper>}
      placement={placement || 'right'}
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -8]
            }
          }
        ],
        sx: {
          ...(popperZIndex != null && { zIndex: popperZIndex }),
          '& .MuiTooltip-tooltip': {
            maxWidth: 'none'
          }
        }
      }}
      disableInteractive={true}
    >
      {isDisabledChild ? (
        <DisabledChildWrapper>{children}</DisabledChildWrapper>
      ) : (
        children
      )}
    </Tooltip>
  )
}

const DisabledChildWrapper = styled.span`
  display: inline-flex;
  max-width: 100%;
`

const TooltipWrapper = styled.div`
  max-width: 500px;
  width: max-content;
  padding: 8px 12px !important;
  background-color: ${({ theme }) => theme.colors.white};
  border: ${({ theme }) => `2px solid ${theme.colors.menuHover}`};
  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.shadows.imageBackdrop};
  color: ${({ theme }) => theme.colors.black};
  text-align: left;
`
